import React, { useEffect, useState } from 'react';
import { DocumentProps, pdfjs } from 'react-pdf';
import Backdrop from 'tradevan-ui/Backdrop';
import ControlPanel from './components/ControlPanel';
import UiStateI from './type';
import PDFPrinter from './components/PDFPrinter';
import { DocumentStyled, PageStyled, PDFReaderDivStyled } from './styles';

export interface PDFReaderProps {
  onClose: () => void;
  show: boolean;
  file: string;
  customChild?: JSX.Element;
}

const PDFReader = (props: PDFReaderProps): JSX.Element => {
  const {
    onClose,
    show = false,
    file,
    customChild = <PDFPrinter file={file} />,
  } = props;
  const initUiState: UiStateI = {
    scale: 1.2,
    currentPage: 1,
    pages: 1,
    isLoading: true,
  };
  const [uiState, setUiState] = useState(initUiState);

  const handleDocumentLoadSuccess: DocumentProps['onLoadSuccess'] = (pdf) => {
    const { numPages } = pdf;
    setUiState({
      ...uiState,
      ...initUiState,
      isLoading: false,
      pages: numPages,
    });
  };

  useEffect(() => {
    // pdf.worker.min.js 有簡體字問題
    // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    pdfjs.GlobalWorkerOptions.workerSrc = '/plugin/pdf-dist/pdf.worker.js';
  }, []);

  // 移至頂部並設定 overflow: hidden
  useEffect(() => {
    if (show) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.classList.add('overflow-hidden');
    } else document.documentElement.classList.remove('overflow-hidden');
  }, [show]);

  return (
    <Backdrop show={show}>
      <PDFReaderDivStyled>
        <ControlPanel
          uiState={uiState}
          setUiState={setUiState}
          onClose={onClose}
          customChild={customChild}
        />
        <DocumentStyled
          // text layer display error
          options={{
            cMapUrl: `/plugin/pdf-dist/cmaps/`,
            cMapPacked: true,
          }}
          file={file}
          onLoadSuccess={(pdf) => handleDocumentLoadSuccess(pdf)}
          // onLoadError={(error) => console.log(error)}
        >
          <PageStyled pageNumber={uiState.currentPage} scale={uiState.scale} />
        </DocumentStyled>
      </PDFReaderDivStyled>
    </Backdrop>
  );
};

export default PDFReader;
